import { useEffect, useState } from "react";
import { ChevronDown, Trash2, MessageCircle } from "lucide-react";
import { api } from "@/lib/api";
import { WA_LINK } from "@/data/content";

const LABELS = {
  name: "Name", phone: "Phone", email: "Email", form_type: "Type", location: "Location",
  project_category: "Category", project_type: "Project type", plot_area: "Plot area",
  built_up_area: "Built-up area", floors: "Floors", preference: "Preference",
  timeline: "Timeline", message: "Message", created_at: "Submitted",
};

export const EnquiriesTab = () => {
  const [items, setItems] = useState(null);
  const [openId, setOpenId] = useState(null);

  const load = () => api.get("/admin/enquiries").then((r) => setItems(r.data)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);

  const toggleRead = async (item) => {
    await api.patch(`/admin/enquiries/${item.id}`, { read: !item.read });
    load();
  };

  const remove = async (item) => {
    if (!window.confirm(`Delete enquiry from ${item.name}?`)) return;
    await api.delete(`/admin/enquiries/${item.id}`);
    load();
  };

  if (items === null) return <p className="text-sm text-charcoal/50">Loading…</p>;
  if (items.length === 0) return <p className="text-sm text-charcoal/50" data-testid="enquiries-empty">No enquiries yet.</p>;

  return (
    <div className="space-y-3" data-testid="enquiries-list">
      {items.map((item) => (
        <div key={item.id} className={`rounded-xl border bg-white ${item.read ? "border-charcoal/10" : "border-gold-dark/50"}`}>
          <button type="button" data-testid={`enquiry-row-${item.id}`} onClick={() => setOpenId(openId === item.id ? null : item.id)}
            className="flex w-full items-center gap-4 px-5 py-4 text-left">
            {!item.read && <span className="h-2 w-2 shrink-0 rounded-full bg-gold-dark" aria-label="Unread" />}
            <span className="w-36 shrink-0 text-xs text-charcoal/45">{new Date(item.created_at).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" })}</span>
            <span className="flex-1 truncate text-sm font-bold text-charcoal">{item.name}</span>
            <span className="hidden text-sm text-charcoal/60 sm:block">{item.phone}</span>
            <span className="rounded-full bg-charcoal/5 px-3 py-1 text-[10px] font-bold uppercase tracking-wider text-charcoal/60">{item.form_type}</span>
            <ChevronDown className={`h-4 w-4 text-charcoal/40 transition-transform ${openId === item.id ? "rotate-180" : ""}`} />
          </button>
          {openId === item.id && (
            <div className="border-t border-charcoal/10 px-5 py-5">
              <dl className="grid gap-x-8 gap-y-3 sm:grid-cols-2">
                {Object.entries(LABELS).map(([key, label]) => (
                  <div key={key}>
                    <dt className="text-[10px] font-bold uppercase tracking-widest text-charcoal/40">{label}</dt>
                    <dd className="text-sm text-charcoal/80">{item[key] || "Not provided"}</dd>
                  </div>
                ))}
              </dl>
              <div className="mt-5 flex flex-wrap gap-3">
                <a href={WA_LINK(`Hi ${item.name}, this is D & N Constructions regarding your enquiry.`)}
                  target="_blank" rel="noreferrer" data-testid={`enquiry-whatsapp-${item.id}`}
                  className="inline-flex items-center gap-1.5 rounded-full bg-gold px-4 py-2 text-xs font-bold text-charcoal">
                  <MessageCircle className="h-3.5 w-3.5" /> Reply on WhatsApp
                </a>
                <button type="button" onClick={() => toggleRead(item)} data-testid={`enquiry-read-${item.id}`}
                  className="rounded-full border border-charcoal/20 px-4 py-2 text-xs font-bold text-charcoal/60">
                  {item.read ? "Mark unread" : "Mark read"}
                </button>
                <button type="button" onClick={() => remove(item)} data-testid={`enquiry-delete-${item.id}`}
                  className="inline-flex items-center gap-1.5 rounded-full border border-red-200 px-4 py-2 text-xs font-bold text-red-600">
                  <Trash2 className="h-3.5 w-3.5" /> Delete
                </button>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
